import { cn } from "~/lib/utils";

/**
 * El check del landing. ÚNICO estándar para toda la superficie pública.
 *
 * Existía duplicado y divergente: en algunas secciones el glifo `☑` (chico, gris y
 * desalineado respecto de la línea base) y en otras este disco verde. Al vivir en un
 * componente, agregar un check nuevo ya no puede introducir un estilo distinto.
 */
export function CheckMark({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 16 16"
      className={cn("h-[15px] w-[15px] shrink-0", className)}
    >
      <circle cx="8" cy="8" r="8" fill="#357A50" />
      <path
        d="M4.5 8.3 L6.9 10.7 L11.5 5.8"
        fill="none"
        stroke="#fff"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
